/**
 * @link https://mui.com/material-ui/react-typography/
 */

import { Typography } from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeTypography() {
  const typographyExample = `<>
  <Typography variant="h1">Heading 1</Typography>
  <Typography variant="h2">Heading 2</Typography>
  <Typography variant="h3">Heading 3</Typography>
  <Typography variant="h4">Heading 4</Typography>
  <Typography variant="h5">Heading 5</Typography>
  <Typography variant="h6">Heading 6</Typography>
  <Typography variant="subtitle1">Subtitle 1</Typography>
  <Typography variant="subtitle2">Subtitle 2</Typography>
  <Typography variant="body1">Body 1</Typography>
  <Typography variant="body2">Body 2</Typography>
</>`;

  return (
    <>
      <Typography variant="h1">Hello Headline H1</Typography>
      <Typography variant="h2">Hello Headline H2</Typography>
      <Typography variant="h3">Hello Headline H3</Typography>
      <Typography variant="h4">Hello Headline H4</Typography>
      <Typography variant="h5">Hello Headline H5</Typography>
      <Typography variant="h6">Hello Headline H6</Typography>

      <br/>

      <Typography variant="subtitle1">Hello Subtitle</Typography>
      <Typography variant="subtitle2">Hello Subtitle 2</Typography>

      <br/>

      <Typography variant="body1">Hello plain text paragraph. (Body)</Typography>
      <Typography variant="body2">Hello plain text paragraph. (Body2)</Typography>

      <ShowCode codeString={typographyExample} scope={{ React, Typography }} />
    </>
  )
}